import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=80c49778&scoped=true"
import script from "./NoteModal.vue?vue&type=script&lang=js"
export * from "./NoteModal.vue?vue&type=script&lang=js"
import style0 from "./NoteModal.vue?vue&type=style&index=0&id=80c49778&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c49778",
  null
  
)

export default component.exports